import nextTick from 'goog:goog.async.nextTick';
import {
  listenOnce,
  Listenable,
  Event,
  EventId,
  BrowserEvent,
} from 'goog:goog.events';

export function timedPromise(milliseconds: number): Promise<void> {
  return new Promise((resolve, _) => {
    setTimeout(() => {
      resolve();
    }, milliseconds);
  });
}

export function eventPromise<T = Event, K = unknown>(
  eventTarget: Listenable | EventTarget,
  eventId: string | EventId<T>,
  failureEventId?: string | EventId<K>
): Promise<T> {
  return new Promise((resolve, reject) => {
    listenOnce(eventTarget, eventId, (event) => {
      if (event instanceof BrowserEvent) {
        const browserEvent = event.getBrowserEvent();
        if (browserEvent) {
          event = browserEvent as any;
        }
      }
      resolve(event);
    });

    if (failureEventId) {
      listenOnce(eventTarget, failureEventId, reject);
    }
  });
}

let framePromise: Promise<void> | undefined;
export function nextFrame(): Promise<void> {
  if (!framePromise) {
    framePromise = new Promise((resolve) => {
      requestAnimationFrame(() => {
        framePromise = undefined;
        resolve();
      });
    });
  }
  return framePromise;
}

// awaitable version of goog.async.nextTick
export async function nextTickPromise(): Promise<void> {
  await new Promise((resolve) => nextTick(() => resolve(null)));
}
